export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref6246.af56e394.jpg";